export const GET_APPLICATIONS = 'Get_Applications';